/**
 * @author: Wangwei
 * @description: 打卡营首页 我参加的打卡营
 */
import styles from './css/campUnderwayCard.less';
import { useRequest } from 'umi';
import { useEffect, useState } from 'react';
import cx from 'classnames';
import { Flex, Progress, Button } from 'antd';
import { getCampUnderwayList } from '@/utils/requests/camp/requests_study';
import DateFormat from '@/components/dateFormat';
import MoreLink from '@/components/moreLink';
import { CampStudyVO } from '@/types/camp/campIndex/indexTypes';
import { CampStudyState } from '@/types/camp/study';
import campSuccessSvg from '@/static/images/camp_success.svg';
import campFailSvg from '@/static/images/camp_fail.svg';

const CampUnderwayCard = () => {
  const [underwayList, setUnderwayList] = useState<CampStudyVO[]>([]);

  const getAllProductRequest = useRequest(
    () => {
      return getCampUnderwayList();
    },
    {
      manual: true,
      onSuccess: (res) => {
        setUnderwayList(res);
      },
      onError: (e) => {},
    },
  );

  useEffect(() => {
    getAllProductRequest.run();
  }, []);

  return (
    <>
      {underwayList.length > 0 && (
        <div style={{ marginBottom: 48 }}>
          <div className="flex_3" style={{ marginBottom: 16 }}>
            <span className="f24 fw600 flex_2">最近打卡</span>
            <MoreLink
              text="所有打卡记录"
              css="f14 col5a5 hover008"
              iconCss="f12"
              url="/v2/myStudy?tab=camp"
            />
          </div>
          <div className={styles.camp_underway}>
            {underwayList.map((item, index) => (
              <div key={index} className={cx(styles.item, 'flex_3')}>
                <div className={styles.lf}>
                  <div style={{ position: 'relative' }}>
                    <img className={styles.cover} width={268} src={item.simpleCamp.cover} alt="" />
                    <div
                      style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                      }}
                    >
                      {item.campStudyState === 3 && (
                        <img src={campSuccessSvg} width={48} height={48} />
                      )}
                      {item.campStudyState === 2 && (
                        <img src={campFailSvg} width={48} height={48} />
                      )}
                    </div>
                  </div>
                  <div className={cx(styles.info, 'flex_2')}>
                    <a
                      href={`/v2/camp/class/${item.batchId}`}
                      className={cx(styles.title, 'f20 col172 hover008 hide_txt')}
                    >
                      <span style={{ paddingRight: 10 }}>{item.simpleCamp.name}</span>
                      <span>{item.batch.name}</span>
                    </a>
                    <div className={cx(styles.my_data, 'f14 col808')}>
                      <div className={styles.score}>
                        我的学分：<span className="colffa f16">{item.campScore}</span>
                      </div>

                      <div className={styles.rank}>
                        当前排名：<span className="colffa f16">{item.myRanking}</span>
                        <span>/{item.allStudent}</span>
                      </div>
                    </div>
                    <div className={styles.progress}>
                      <div className="flex_3" style={{ marginBottom: 4, marginTop: 10 }}>
                        <div>
                          {item.lastStudyNode &&
                            item.campStudyState === CampStudyState.STUDYING && (
                              <span className="col808 hide_txt">
                                接下来打卡：{item.lastStudyNode.name}
                              </span>
                            )}
                          {item.campStudyState === CampStudyState.CAMP_SUCCESS && (
                            <span className="col00c">打卡成功</span>
                          )}
                          {item.campStudyState === CampStudyState.CAMP_FAIL && (
                            <span className="colff6">打卡失败</span>
                          )}
                          {item.campStudyState === CampStudyState.WAITING_RESULTS && (
                            <span className="col808">学习结束，请等待公布成绩</span>
                          )}
                        </div>
                        <span className="colc0c">
                          进度：{item.successNode}/{item.allNode}
                        </span>
                      </div>
                      <Flex gap="small" vertical>
                        <Progress
                          percent={(item.successNode / item.allNode) * 100}
                          showInfo={false}
                          strokeColor={
                            item.successNode / item.allNode === 1 ? '#52c41a' : '#FAAD14'
                          }
                        />
                      </Flex>
                    </div>
                  </div>
                </div>
                <div className={styles.rt}>
                  <div className={cx(styles.rt_box, 'flex_1 flex_2')}>
                    <div style={{ minHeight: 20 }}>
                      {item.campStudyState === CampStudyState.STUDYING && (
                        <DateFormat endTime={item.batch.enTime} endText="后结束" />
                      )}
                      {item.campStudyState === CampStudyState.WAITING_RESULTS && (
                        <DateFormat endTime={item.batch.rewardTime} endText="后公布成绩" />
                      )}
                    </div>
                    <a
                      className="com_camp_btn"
                      href={`/v2/camp/class/${item.batchId}`}
                      style={{
                        width: 200,
                        height: 40,
                        fontSize: 15,
                        borderRadius: 6,
                        marginTop: 8,
                      }}
                      target="_blank"
                    >
                      进入打卡营
                    </a>
                    <a
                      className="com_camp_btn_def"
                      href={`/v2/camp/${item.cardCampId}`}
                      style={{ width: 200, height: 40, fontSize: 15, borderRadius: 6 }}
                      target="_blank"
                    >
                      查看招生页
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
export default CampUnderwayCard;
